// extracted by mini-css-extract-plugin
module.exports = {"content":"Auth_content__3VCMJ","avatar":"Auth_avatar__29y74"};